import { useEffect } from 'react';
import { SessionMetrics } from '@components/Questions/Question';

export const useQuestionMetrics = ({ questionId }: { questionId: string }) => {
	useEffect(() => {
		const storedMetrics = sessionStorage.getItem('sessionMetrics');
		sessionStorage.setItem('currentQuestionId', questionId);
		const newMetricsItem = {
			questionId: questionId,
			openedTime: new Date().getTime(),
		};

		if (storedMetrics) {
			const sessionMetrics = JSON.parse(storedMetrics) as SessionMetrics[];

			const isQuestionAlreadyInMetrics = sessionMetrics.some((metric) => {
				return metric.questionId === questionId;
			});
			if (!isQuestionAlreadyInMetrics) {
				sessionMetrics.push(newMetricsItem);
			}
			const updatedMetrics = sessionMetrics.map((metric) => {
				if (metric.questionId === questionId) {
					metric.openedTime = new Date().getTime();
				}
				return metric;
			});

			sessionStorage.setItem('sessionMetrics', JSON.stringify(updatedMetrics));
		} else {
			sessionStorage.setItem('sessionMetrics', JSON.stringify([newMetricsItem]));
		}
	}, [questionId]);
};
